/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExerciseConfig } from './ExerciseConfig';
import {
    ExerciseConfigFromJSON,
    ExerciseConfigFromJSONTyped,
    ExerciseConfigToJSON,
    ExerciseConfigToJSONTyped,
} from './ExerciseConfig';

/**
 * 
 * @export
 * @interface PlanExercise
 */
export interface PlanExercise {
    /**
     * 
     * @type {string}
     * @memberof PlanExercise
     */
    exerciseId: string;
    /**
     * 
     * @type {ExerciseConfig}
     * @memberof PlanExercise
     */
    exerciseConfig: ExerciseConfig;
}

/**
 * Check if a given object implements the PlanExercise interface.
 */
export function instanceOfPlanExercise(value: object): value is PlanExercise {
    if (!('exerciseId' in value) || value['exerciseId'] === undefined) return false;
    if (!('exerciseConfig' in value) || value['exerciseConfig'] === undefined) return false;
    return true;
}

export function PlanExerciseFromJSON(json: any): PlanExercise {
    return PlanExerciseFromJSONTyped(json, false);
}

export function PlanExerciseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanExercise {
    if (json == null) {
        return json;
    }
    return {
        
        'exerciseId': json['exerciseId'],
        'exerciseConfig': ExerciseConfigFromJSON(json['exerciseConfig']),
    };
}

export function PlanExerciseToJSON(json: any): PlanExercise {
    return PlanExerciseToJSONTyped(json, false);
}

export function PlanExerciseToJSONTyped(value?: PlanExercise | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exerciseId': value['exerciseId'],
        'exerciseConfig': ExerciseConfigToJSON(value['exerciseConfig']),
    };
}

